import { render, staticRenderFns } from "./BboxPreview.vue?vue&type=template&id=b201c40e&"
import script from "./BboxPreview.vue?vue&type=script&lang=ts&"
export * from "./BboxPreview.vue?vue&type=script&lang=ts&"
import style0 from "./BboxPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports